import './style.scss';
import onDocumentReady from 'shared/onDocumentReady';
import { createApp } from '~/vue/createApp';
import DeleteAccountNotification from './DeleteAccountNotification.vue';

// see site_header/index.js for what the conversion from `new Vue({el, render})` changes
function initVue() {
    const el = document.getElementById('delete-account-notification-component');
    if (!el) {
        return;
    }
    createApp(DeleteAccountNotification).mount(el);
}

onDocumentReady(initVue);
